export const hasStringHTMLTags = (value?: string): boolean => {
  if (!value) return true
  if (value?.search(/<\/?[a-z][\s\S]+/) !== -1) return false
  return true
}
